/* globals lp, rxSwitchboard */
var Rx = require('ub_wrapped/rx');
var ubBanzai = require('ub/control/banzai-features');
var InvariantsHelper = require('./editor/invariants/invariants-helper');
var _ = require('lodash');
var helper = InvariantsHelper;

window.pomValidator = require('pom-validation/lib/validate');

;(function () {
  lp.invariants = {}; // namespace

  var _registry = {}; // {name: invariantFn}
  lp.invariants._registry = _registry;

  //////////////////////////////////////////////////////////////////////
  // Logging
  // used for logging additional information from inside invariant
  // functions while they're running
  var LogMarker = function(invariantName) {
    this.name = invariantName;
  };
  // Observable of [LogMarker('invariant1'), 'log msg', 'log msg2', LogMarker('invariant2'), 'log msg3']
  var _logSubject = new Rx.Subject();
  lp.invariants.logSubject = _logSubject;
  var log = _logSubject.onNext.bind(_logSubject);

  var register = function(name, assertionFn) {
    _registry[name] = assertionFn;
  };

  var assert = function(booleanVal, msg) {
    if (!booleanVal) {
      var err = new Error(msg || 'Assertion Error');
      err.isAssertionError = true;
      throw err;
    } else {
      return true;
    }
  };

  var _runSingleAssertion = function(name, assertionFn, throwOnAssertException) {
    log(new LogMarker(name));
    try {
      var boundAssert = _.partialRight(assert, 'Assert ' + name);
      return boundAssert(assertionFn(window.editor, boundAssert));
    } catch (e) {
      if (throwOnAssertException) {
        throw e;
      }
      if (e.isAssertionError) {
        log(e);
        log(e.stack);
      } else {
        log('Invariant assertion ' + name + ' threw an exception:');
      }
      return e;
    }
  };

  var _checkInvariants = function(acc, assertionFnOrGroup, name, throwOnAssertException) {
    if (!_.isFunction(assertionFnOrGroup)) {
      // it's a keyed group of invariants, so we prefix their names then recurse
      var childChecks = _.transform(assertionFnOrGroup, function(acc, val, key) {
        acc[name + ' - ' + key] = val;
      });
      var childResults = _.transform(
        childChecks,
        function(acc2, assertionFnOrGroup2, name2) {
          return _checkInvariants(acc2, assertionFnOrGroup2, name2, throwOnAssertException);
        });
      _.merge(acc, childResults);
      // store the result of the entire group:
      acc[name] = _.all(_.values(childResults));
      return;
    } else {
      acc[name] = _runSingleAssertion(name, assertionFnOrGroup, throwOnAssertException);
    }

  };

  var check = function(args) {
    /* args.checks: [string] || null, optional list of invariants to use
       args.throwOnAssertException: bool, default false
    */
    var invariantsToCheck;
    if (args && args.checks && args.checks.length > 0) {
      invariantsToCheck = _.pick(_registry, args.checks);
    } else {
      invariantsToCheck = _.clone(_registry);
    }
    // return a hash of failed invariants
    return _.transform(
      invariantsToCheck,
      function(acc, assertionFnOrGroup, name) {
        return _checkInvariants(acc, assertionFnOrGroup, name, (args && args.throwOnAssertException));
      }
    );
  };

  var reportFailureOnConsole = function(failed) {
    if (!_.isEmpty(failed)) {
      console.group("%cInvariants failed", "color:yellow; background:red; font-size: 13pt");
      _.forEach(failed, function(val, key) {
        console.log(key);
        if(val instanceof Error) {
          console.log(val, val.stack);
        }
      });
      console.groupEnd();
    }
  };

  var debug = function(throwOnAssertException) {
    var failed = _.pick(check({
        throwOnAssertException: throwOnAssertException
      }),
      function(v /*, key */ ) {
        return !v || (v instanceof Error);
      });
    reportFailureOnConsole(failed);
    return failed;
  };
  //////////////////////////////////////////////////////////////////////
  // public api
  lp.invariants.log = log;
  lp.invariants.assert = assert;
  lp.invariants.register = register;
  lp.invariants.check = check;
  lp.invariants.debug = debug;

  lp.invariants.activate = function() {
    Rx.Observable
      .interval(4000)
      .filter(function() {return ! helper.isElementBeingDragged();})
      .map(lp.invariants.check)
      .map(function(results) {
        return _.pick(results, function(v /*, key */ ) {
          return !v || v instanceof Error; // This is to make sure the errors from assert get propagated
        });
      })
      .filter(function(results) {
        return !_.isEmpty(results);
      })
      .take(3) // only log the first few
      .subscribe(reportFailureOnConsole);
  };
  //////////////////////////////////////////////////////////////////////
  if (ubBanzai.features.isCheckInvariantsEnabled()) {
    rxSwitchboard.subjects.page_loaded.subscribe(lp.invariants.activate);
  }
})();



//////////////////
// WEBPACK FOOTER
// ./src/legacy/lp/invariants.js
// module id = 728
// module chunks = 0